import { configureStore } from "@reduxjs/toolkit";
import selectedTutorSlice from "./selectedTutor.js";
import thisUserSlice from "./thisUser.js";
import thisTutorSlice from "./thisTutor.js";

const store = configureStore({
  reducer: {
    selectedTutor: selectedTutorSlice.reducer,
    thisUser: thisUserSlice.reducer,
    thisTutor: thisTutorSlice.reducer,
  },
});

export default store;
